module.exports = __webpack_public_path__ + "img/gt.ce11cd36.svg";